import { render } from "./Builder.vue?vue&type=template&id=46e06685"
import script from "./Builder.vue?vue&type=script&lang=js"
export * from "./Builder.vue?vue&type=script&lang=js"

import "./Builder.vue?vue&type=style&index=0&id=46e06685&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.16.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__